import { SubventionsError } from "@/features/subventions/components/SubventionsError";
import { SubventionsFeedView } from "@/features/subventions/components/SubventionsFeedView";
import { useSubventions } from "@/features/subventions/hooks/useSubventions";
import { PageBanner } from "@/shared/components/banner";
import { CenteredSpinner } from "@/shared/components/centeredSpinner";

export const SubventionsPage = () => {
  const {
    data, cheques, isLoading, isError, refetch,
  } = useSubventions();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <CenteredSpinner />
      </div>
    );
  }

  return (
    <div className="page-animation flex flex-col gap-6">
      <PageBanner
        title="Mes Subventions"
        subtitle="Consultez et utilisez vos subventions et avantages offerts par votre CSE pour réduire le montant à payer lors de vos achats."
        icon="subventions.png"
        pageKey="subventions"
      />

      {isError
        ? (<SubventionsError onRetry={refetch} />)
        : (<SubventionsFeedView data={data} cheques={cheques} />)}
    </div>
  );
};

SubventionsPage.displayName = "SubventionsPage";
